// extracted by mini-css-extract-plugin
export var container = "RelatedProductsContainer-module--container--9v8qt";
export var ctas = "#226355";
export var grayBackground = "#f6f8fb";
export var productContainer = "RelatedProductsContainer-module--productContainer--qsU7p";
export var title = "RelatedProductsContainer-module--title--D+w+7";
export var titleContainer = "RelatedProductsContainer-module--titleContainer--Lyp59";